import { Flex, Text } from "@/atoms"
import { Code } from "@/molecules/Code"
import { AppRegistrationValue } from "./AppRegistrationValue"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

import type { FederatedCredentialProps } from "./AppRegistrationSteps.types"

// The Entra app registration and its federated credential Kodem signs in with
export const FederatedCredential = ({
  preInstall
}: FederatedCredentialProps) => {
  const t = useAppRegistrationTranslation()

  return (
    <Flex vertical gap={8}>
      <Text>{t("create")}</Text>
      <Text>{t("federatedCredential")}</Text>
      <Code.CommandCard>
        <AppRegistrationValue label={t("issuer")} value={preInstall.issuer} />
        <AppRegistrationValue label={t("subject")} value={preInstall.subject} />
        <AppRegistrationValue
          label={t("audience")}
          value={preInstall.audience}
        />
      </Code.CommandCard>
    </Flex>
  )
}
